import { Equipment } from '../equipment'

type VehiclePartial = {
  licensePlate: string
  vin: string
  dateProduction: string | null
  dateDelivery: string | null
  dateFirstReg: string
  dateLastReg: string | null
  color: string
  typeRegDoc: string | null
  type: string | null
  bodyType: string
  bodyTypeRegDoc: string
  fuelType: string
  fuelTypeRegDoc: string
  euroNorm: string | unknown
  euroNormRegDoc: string | unknown
  curbWeight: string | unknown
  totalWeight: string | unknown
  typeCode: null | unknown
  deliveryCountry: null | unknown
  critair: string | unknown
  numberOfSeats: number | unknown
  numberOfDoors: number | unknown
  numberOfCylinders: number | unknown
  equipments: Array<Equipment>
}

const defaultVehiclePartial: VehiclePartial = {
  licensePlate: '',
  vin: '',
  dateProduction: null,
  dateDelivery: '',
  dateFirstReg: '',
  dateLastReg: null,
  color: '',
  typeRegDoc: null,
  type: '',
  bodyType: '',
  bodyTypeRegDoc: '',
  fuelType: '',
  fuelTypeRegDoc: '',
  euroNorm: '',
  euroNormRegDoc: '',
  curbWeight: '',
  totalWeight: '',
  typeCode: null,
  deliveryCountry: null,
  critair: '',
  numberOfSeats: 0,
  numberOfDoors: 0,
  numberOfCylinders: 0,
  equipments: [],
}

export type { VehiclePartial }
export { defaultVehiclePartial }
